import { memo, useMemo } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

import { DEFAULT_APP_THEME } from "constants/settings";
import { organizationTitleByAppTheme } from "constants/theming";
import { useAppTheme } from "contexts/useAppThemeContext";

const SEPARATOR = " | ";

type DocumentTitleProps = {
  seo?: boolean;
  titlePath: string | string[];
};

export const DocumentTitle = memo(function DocumentTitle({
  seo = true,
  titlePath,
}: DocumentTitleProps) {
  const { t } = useTranslation();
  const { appTheme } = useAppTheme();

  const title = useMemo(
    () =>
      (Array.isArray(titlePath) ? titlePath : [titlePath])
        .map((pathBlock) => (t(pathBlock) ? t(pathBlock) : pathBlock))
        .concat(organizationTitleByAppTheme[appTheme || DEFAULT_APP_THEME])
        .join(SEPARATOR),
    [titlePath, appTheme],
  );

  return (
    <Helmet>
      <title>{title}</title>
      {seo && (
        <>
          <meta content={title} property="og:title" />
          <meta content={title} name="twitter:title" />
        </>
      )}
    </Helmet>
  );
});
